/* eslint-disable no-unused-vars */

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Icon from 'shared/Icon';
import theme from 'styles/theme';
import { IState } from 'store';
import { IChatState } from 'store/modules/chat/types';
import { handleChatButton } from 'utils/general';
import { Container } from './styles';

const Z_INDEX_ABOVE_HIGH_STACKING_FORMS = 9999998;

const HIGH_STACKING_FORM_PATHS = ['/request/medical-certificate', '/request/transport/unlock'];

const FloatingChatButton: React.FC = () => {
  const { loaded } = useSelector<IState, IChatState>((state) => state.chat);
  const { pathname } = useLocation();
  const elevateForHighStackingForms = HIGH_STACKING_FORM_PATHS.includes(pathname);

  return (
    <Container
      id="chatButtonFooter"
      className="chatButton"
      style={elevateForHighStackingForms ? { zIndex: Z_INDEX_ABOVE_HIGH_STACKING_FORMS } : undefined}
      onClick={() => handleChatButton()}
    >
      <Icon name="chatCircle" color={theme.colors.white} width="30" height="30" />
      <p>Precisa de ajuda?</p>
    </Container>
  );
};

export default FloatingChatButton;
